import { getBulkValue } from './factories';

export const getBulkValueDate = getBulkValue('valueDate');
